/**
 * Which of a linked group's lists its drops go to (user, 19/10/2026: "or we
 * have 1 list and if it's terrible the next day it changes, or we use all
 * lists of the group in the drop slot — but if there are 500, a limit of
 * 10" — then "an option to alternate lists, to see which list on the
 * hour"). The link's listsPerDay: 1 = one list; N ≥ 2 = all of its N best
 * lists (0, older rows only = no limit), each drop to every list (EACH) or
 * one list per drop, in turn (ALTERNATE).
 * For Media Devoted | Created By Ciro Autiero
 */

export type ListChoice = 'one' | 'all';

export const ALL_LISTS_CAP = { default: 10, min: 2, max: 50 } as const;

export const listChoiceOf = (listsPerDay: number | undefined): ListChoice =>
  listsPerDay === undefined || listsPerDay === 1 ? 'one' : 'all';

/** How many lists an "all lists" group sends to: its limit, never more than it has. */
export function allListsCount(listsPerDay: number, listCount: number | null): number | null {
  if (listsPerDay <= 0) return listCount;
  return listCount === null ? listsPerDay : Math.min(listsPerDay, listCount);
}

/** How the group ranks its lists, in words — the formula, or the order. */
export function rankWords(orderMode: string): string {
  if (orderMode === 'FORMULA') return 'by the formula';
  return orderMode === 'MANUAL' ? 'in your order' : "in the group's order";
}

/** The verdict — says only what the engine will really do. A formula group
 *  starts every generate on the formula's #1 (02/11/2026), verdict or not. */
export function verdictWords(oneList: boolean, verdictOn: boolean, formula = false): string {
  if (!verdictOn && oneList && formula)
    return "The list verdict is off: no list burns for its results. Generate now and the daily auto-generate start on the formula's #1; during the day the list stays.";
  if (!verdictOn)
    return oneList ? 'The list verdict is off: the list stays until it runs dry.' : 'The list verdict is off: no list leaves for its results.';
  if (!oneList) return 'Each list is judged on its own: a terrible one leaves, the next best joins the next day.';
  return 'A terrible verdict → the next list takes over the next day.';
}
